import {IconButton, Tooltip, Typography} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";
import {BsXSquare} from "react-icons/bs";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";


const TABLE_HEAD = ["#", "رشته", "گرایش", "مشاوره", "هزینه خدمات", "زمان خدمات", "عملیات"];

export function BackOfficeAgentBranchFeeGrid({
                                               AgentBranchFees,
                                               setModalOpen,
                                               setSelectedRow,
                                             }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "branch_id",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "توضیحات": "description",
    "مشاوره": "consultation_commission",
    "خدمات": "service_commission",
    "عملیات": "",
  }

  const headSortable = {
    "#": false,
    "رشته": true,
    "گرایش": true,
    "توضیحات": true,
    "مشاوره": true,
    "خدمات": true,
    "عملیات": false,
  }

  return (
    <div>
      <table className="mt-4 text-center w-full">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter">
        {AgentBranchFees.map(
          ({
             branch_id,
             field_title,
             branch_title,
             consultation_status,
             consultation_price,
             service_status,
             consensual,
             service_price,
             min_price,
             max_price,
             period,
             day,
             min_day,
             max_day,
           }, index) => {
            const isLast = index === AgentBranchFees.length - 1;
            const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

            return (
              <tr key={branch_id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textCenter">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textCenter">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    {
                      consultation_status === 'enable' ?
                        <Typography>
                          {`${persianNumberFormat(consultation_price, true)} ریال`}
                        </Typography>
                        :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    {
                      service_status === 'enable' ?
                        !consensual ?
                          <div className="flex flex-col">
                            <div className="flex flex-row justify-center">
                              <Typography>
                                {`${persianNumberFormat(service_price, true)} ریال`}
                              </Typography>
                            </div>
                          </div> :
                          consensual ?
                            <div className="flex flex-col">
                              <div className="flex flex-row justify-center">
                                <Typography>
                                  {`از ${persianNumberFormat(min_price, true)} تا ${persianNumberFormat(max_price, true)} ریال`}
                                </Typography>
                              </div>
                            </div> :
                            "" :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center">
                    {
                      service_status === 'enable' ?
                        !period ?
                          <div className="flex flex-col">
                            <div className="flex flex-row justify-center">
                              <Typography>
                                {`${persianNumberFormat(day)} روز`}
                              </Typography>
                            </div>
                          </div> :
                          period ?
                            <div className="flex flex-col">
                              <div className="flex flex-row justify-center">
                                <Typography>
                                  {`از ${persianNumberFormat(min_day)} تا ${persianNumberFormat(max_day)} روز`}
                                </Typography>
                              </div>
                            </div> :
                            "" :
                        <BsXSquare color={"red"} size={30}/>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <Tooltip content="عملیات">
                    <IconButton variant="text" className="text-align=right" onClick={() => {
                      setSelectedRow(AgentBranchFees[index]);
                      setModalOpen(true);
                    }}>
                      <PencilIcon className="h-4 w-4"/>
                    </IconButton>
                  </Tooltip>
                </td>
              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}